import { computed } from 'vue-demi';
import { format, utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';
import { useNow } from '@vueuse/core';

const now = useNow();

export default ({ userContext: { user } } = {}) => {
  const timezoneRef = computed(() => user.value?.localization?.timezoneJavaRefCode);

  const dateFormat = computed(() => {
    if (!user.value) {
      return '';
    }

    return user.value.localization.dateFormat.replace('DD', 'dd').replace('mm', 'MM');
  });

  const timeFormat = computed(() => {
    if (!user.value) {
      return '';
    }

    return user.value.localization.timeFormat.replace('tt', 'a').replace(/hh:mm/i, 'HH:mm');
  });

  const convertUtcToZonedTime = (_date) => {
    if (!timezoneRef.value) {
      return null;
    }

    if (!(_date instanceof Date) && typeof _date !== 'string') {
      return null;
    }

    const date = typeof _date === 'string' ? new Date(_date) : _date;

    return utcToZonedTime(date, timezoneRef.value);
  };

  const convertZonedTimeToUtc = (_date) => {
    if (!timezoneRef.value) {
      return null;
    }

    if (!(_date instanceof Date) && typeof _date !== 'string') {
      return null;
    }

    const date = typeof _date === 'string' ? new Date(_date) : _date;
    return zonedTimeToUtc(date, timezoneRef.value);
  };

  const convertDateToDateString = (date) => {
    if (!date) {
      return '';
    }

    return format(date, `${dateFormat.value} ${timeFormat.value}`);
  };

  const convertDateToUserDateString = (date) => {
    const zonedDate = convertUtcToZonedTime(date);

    return convertDateToDateString(zonedDate);
  };

  const convertDateToTimeString = (date) => {
    if (!date) {
      return '';
    }

    return format(date, `${timeFormat.value}`);
  };

  const convertDateToUserTimeString = (date) => {
    const zonedDate = convertUtcToZonedTime(date);

    return convertDateToTimeString(zonedDate);
  };

  const nowInUserTimezone = computed(() => convertUtcToZonedTime(now.value));

  return {
    convertDateToDateString,
    convertDateToUserDateString,
    convertUtcToZonedTime,
    convertZonedTimeToUtc,
    convertDateToTimeString,
    convertDateToUserTimeString,
    timezoneRef,
    dateFormat,
    timeFormat,
    nowInUtc: now,
    nowInUserTimezone,
  };
};
